module.exports = __webpack_public_path__ + "img/tab_my.7ed55a68.png";